import React from "react";
import { Col, Row } from "react-bootstrap";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "../styles/index.scss";
// import michLogo from "../assets/michLogo.png";

const MENU_PDF_URL =
  "https://pub-c0a3124b1eba40e9872e4af9857c5272.r2.dev/menu.pdf";

function Index() {
  const downloadFile = async (event) => {
    event.preventDefault();

    try {
      const res = await fetch(MENU_PDF_URL);
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "menu.pdf";
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
      alert("Failed to download menu.");
    }
  };

  return (
    <div>
      <Header position={true} />
      <div className="mainContainer">
        <div className="mainContainer__content">
          {/* =========HOMEEE======= */}
          <div className="main__container_gorkhali">
            <Row>
              <Col lg={12}>
                <div className="mainContainer__content__title text-center">
                  <img
                    // src={michLogo}
                    // src="https://firebasestorage.googleapis.com/v0/b/gorkhalikitchentampa.appspot.com/o/images%2FmichLogo-2025.png?alt=media&token=06483110-73c8-4662-8d56-e12dcbf324f3"
                    src="https://pub-c0a3124b1eba40e9872e4af9857c5272.r2.dev/michLogo-2025.png"
                    alt="Mich Logo 2025"
                    className="michLogo"
                  />
                  <img
                    // src={michLogo2024}
                    // src="https://firebasestorage.googleapis.com/v0/b/gorkhalikitchentampa.appspot.com/o/images%2FmichLogo-2024.png?alt=media&token=d47b5c1f-0b58-4fcf-be4c-77890935ff3b"
                    src="https://pub-c0a3124b1eba40e9872e4af9857c5272.r2.dev/michLogo-2024.png"
                    alt="Mich Logo 2024"
                    className="michLogo"
                  />
                  <img
                    // src={michLogo}
                    // src="https://firebasestorage.googleapis.com/v0/b/gorkhalikitchentampa.appspot.com/o/images%2FmichLogo-2023.png?alt=media&token=df2f1b8b-5e10-4e17-9a90-e5e6396c35f1"
                    src="https://pub-c0a3124b1eba40e9872e4af9857c5272.r2.dev/michLogo-2023.png"
                    alt="Mich Logo 2023"
                    className="michLogo"
                  />
                  <h1>'नमस्ते' WELCOME TO GORKHALI KITCHEN</h1>
                  <h2>Tampa, FL</h2>
                </div>
                <div className="mainContainer__content__description collageImageContainer w85 mx-auto my-2">
                  {/* <div className="kathmanduImage">
                                        <img src={(require('../assets/kathmandu3.jpg'))} alt="kathmandu" />
                                    </div> */}
                  {/* <Row className='image_container'>
                                        <Col xs={6} md={6} className="p-0">
                                            <div className="kathmanduImage">
                                                <img src={(require('../assets/collage1.jpg'))} alt="kathmandu" />
                                            </div>
                                        </Col>
                                        <Col xs={6} md={6} className="p-0">
                                            <div className="kathmanduImage">
                                                <img src={(require('../assets/collage2.jpg'))} alt="kathmandu" />
                                            </div>
                                        </Col>
                                        <Col xs={6} md={6} className="p-0">
                                            <div className="kathmanduImage">
                                                <img src={(require('../assets/collage3.jpg'))} alt="kathmandu" />
                                            </div>
                                        </Col>
                                        <Col xs={6} md={6} className="p-0">
                                            <div className="kathmanduImage">
                                                <img src={(require('../assets/collage4.jpg'))} alt="kathmandu" />
                                            </div>
                                        </Col>
                                    </Row> */}

                  <div className="gorkhali_image_container">
                    <div className="gorkhali_image">
                      <img
                        // src={require("../assets/collage1.jpg")}
                        // src="https://firebasestorage.googleapis.com/v0/b/gorkhalikitchentampa.appspot.com/o/images%2Fcollage1.jpg?alt=media&token=901fc742-7833-4b25-938e-b6e01cb7bfe8"
                        src="https://pub-c0a3124b1eba40e9872e4af9857c5272.r2.dev/collage1.jpg"
                        alt="kathmandu"
                      />
                      <img
                        // src={require("../assets/collage2.jpg")}
                        // src="https://firebasestorage.googleapis.com/v0/b/gorkhalikitchentampa.appspot.com/o/images%2Fcollage2.jpg?alt=media&token=05d0caf2-7f58-4f08-b142-7c8946bc5a6c"
                        src="https://pub-c0a3124b1eba40e9872e4af9857c5272.r2.dev/collage2.jpg"
                        alt="kathmandu"
                      />
                    </div>
                    <div className="gorkhali_image">
                      <img
                        // src={require("../assets/collage3.jpg")}
                        // src="https://firebasestorage.googleapis.com/v0/b/gorkhalikitchentampa.appspot.com/o/images%2Fcollage3.jpg?alt=media&token=efb350b7-a8e7-483f-a2ac-e3e1ef4546eb"
                        src="https://pub-c0a3124b1eba40e9872e4af9857c5272.r2.dev/collage3.jpg"
                        alt="kathmandu"
                      />
                      <img
                        // src={require("../assets/collage4.jpg")}
                        // src="https://firebasestorage.googleapis.com/v0/b/gorkhalikitchentampa.appspot.com/o/images%2Fcollage4.jpg?alt=media&token=fe75848e-329e-48de-bf35-a13f760dfff9"
                        src="https://pub-c0a3124b1eba40e9872e4af9857c5272.r2.dev/collage4.jpg"
                        alt="kathmandu"
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          {/* =========OUR STORY======= */}
          <div
            className="marginDiv"
            style={{ height: "70px" }}
            id="story"
          ></div>
          <div className="main__container_gorkhali">
            <Row>
              <Col lg={12}>
                <div className="mainContainer__content__description w85 mx-auto my-2">
                  <div className="storyline">
                    <h4>OUR STORY</h4>
                    <p>
                      Realizing limited options of Himalayan flavors, the four
                      friends began hatching a plan and with a lot of love and
                      patience, Gorkhali Kitchen opened for business in 2022.
                    </p>
                    <p>
                      We are locally owned and dedicated to serving up great
                      Himalayan-inspired, authentic flavors of Kathmandu City
                      for lunch and dinner. Welcome to our restaurant, we hope
                      you will love it as much as we do!
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="bgImage"></div>
          {/* =========MENU======= */}
          <div className="marginDiv" style={{ height: "70px" }} id="menu"></div>
          <div className="main__container_gorkhali">
            <Row>
              <div className="menu_section">
                <img
                  // src={require("../assets/menu_img.jpg")}
                  // src="https://firebasestorage.googleapis.com/v0/b/gorkhalikitchentampa.appspot.com/o/images%2Fmenu_img.jpg?alt=media&token=4f172254-3e17-4ebc-8044-e652105cf12a"
                  src="https://pub-c0a3124b1eba40e9872e4af9857c5272.r2.dev/menu_img.jpg"
                  alt="menu img"
                  width="369"
                  height="246"
                />
                <button style={{ border: "none", background: "none" }}>
                  <a href={MENU_PDF_URL} download="menu.pdf" onClick={downloadFile}>
                    <span>MENU</span>
                  </a>
                </button>

                <p className="w85">
                  We prepare our dishes with fresh, local and seasonal
                  ingredients.
                </p>
              </div>
            </Row>
          </div>
          {/* =========JOIN OUR TEAM======= */}
          <div className="main__container_gorkhali">
            <Row>
              <div className="mainContainer_join my-lg-5">
                <div className="mainContainer__content__title py-2">
                  <h1>Join Our Team</h1>
                  <h2>Best Nepalese Restaurant</h2>
                </div>
                <div className="memo_para text-center">
                  <p className="w85 text-center">
                    We are looking for restaurant service and kitchen staff with
                    great attitude, who is ready and eager to work in a fast and
                    dynamic restaurant/kitchen. Full time/Part time.
                  </p>
                  <p>
                    Contact us 813 388 6404 or via email:
                    gorkhalikitchentampa@gmail.com
                  </p>
                </div>
              </div>
            </Row>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Index;
